// Components
import ActiveUserTableRow from './ActiveUserTableRow'

const CompanyUsersTable = ({ isAgency, companyUsers }) => (
  <table className="table" id="company-users-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Access</th>
        <th>Admin?</th>
        {
          isAgency && <th className="multi-company-access-heading">Multi-Company Access?</th>
        }
        <th></th>
      </tr>
    </thead>
    <tbody>
      {
        companyUsers.map((companyUser) => (
          <ActiveUserTableRow key={companyUser.id} companyUser={companyUser} />
        ))
      }
    </tbody>
  </table>
)
const mapStateToProps = ({ companyUsers, isAgency }) => ({ companyUsers, isAgency })
export default connect(mapStateToProps)(CompanyUsersTable)



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/CompanyUsersTable.js